<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-06-21 16:36:00
-->
<template>
    <Common>
      <template slot="cd">
          <CdhospitalExamination />
      </template>
      <template slot="sz">
          <SzhospitalExamination />
      </template>
      <template slot="hf">
          <HfhospitalExamination />
      </template>
    </Common>
</template>

<script>
import CdhospitalExamination from "@/components/hospitalExamination/cdhospitalExamination"
import SzhospitalExamination from "@/components/hospitalExamination/szhospitalExamination"
import HfhospitalExamination from "@/components/hospitalExamination/hfhospitalExamination"
export default{
  components:{
    CdhospitalExamination,
    SzhospitalExamination,
    HfhospitalExamination
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>